// A quien llamar esta semana.
//
// Antes decia "15 vencen esta semana" y para saber quienes eran habia que
// irse a otra pantalla y filtrar a mano. Ahora estan aqui con nombre, plan y
// el boton para escribirles: el panel no solo avisa, deja hacer.
//
// Arriba van los tres grupos que se pierden solos si nadie los busca. Abajo,
// los primeros en vencer.

import { Link as RouterLink } from 'react-router';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import Button from '@mui/material/Button';
import ChatRoundedIcon from '@mui/icons-material/ChatRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';

import { numero, soles, cuandoVence } from './formato';
import { Aparece, SUAVE, levanta } from './motion';

/* Un color por plan: el mismo cliente se reconoce por el tono antes de leer
   el texto, y de paso se ve de un golpe si lo que vence es caro o barato. */
const TONO = {
  Fitfuel: 'secondary',
  'Nutrivital Plus': 'info',
  Nutrivital: 'primary',
  Corporativo: 'warning',
};

const iniciales = (nombre) =>
  String(nombre || '?')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((parte) => parte.charAt(0).toUpperCase())
    .join('');

function Contador({ valor, texto, color }) {
  return (
    <Stack
      spacing={.25}
      sx={{
        flex: 1,
        minWidth: 0,
        px: 1.5,
        py: 1.25,
        borderRadius: 2.5,
        bgcolor: `${color}.lighter`,
        transition: `transform .3s ${SUAVE}`,
        '&:hover': { transform: 'translateY(-2px)' },
      }}
    >
      <Typography sx={{ fontSize: 22, fontWeight: 800, lineHeight: 1, color: `${color}.darker` }}>
        {numero(valor)}
      </Typography>
      <Typography sx={{ fontSize: 11.5, lineHeight: 1.25, color: `${color}.darker`, opacity: .8 }}>
        {texto}
      </Typography>
    </Stack>
  );
}

export default function Atencion({ clientes, primeraSemana, porRenovar = [], hoy }) {
  return (
    <Card sx={{ p: 3, height: 1, display: 'flex', flexDirection: 'column', ...levanta }}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
        <Box>
          <Typography sx={{ fontSize: 16, fontWeight: 600 }}>Para llamar esta semana</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {primeraSemana
              ? `${soles(primeraSemana.monto)} que se renuevan o se van`
              : 'Clientes que se pierden solos si nadie los busca'}
          </Typography>
        </Box>

        <Link component={RouterLink} to="/usuarios?segmento=porVencer" sx={{ fontSize: 13.5, fontWeight: 600, flexShrink: 0 }}>
          Ver todos
        </Link>
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <Contador valor={clientes.porVencer7} texto="vencen esta semana" color="warning" />
        <Contador valor={clientes.sinElegir} texto="pagaron y no eligen" color="info" />
        <Contador valor={clientes.nuncaPidieron} texto="nunca pidieron" color="error" />
      </Stack>

      {/* El boton de avisar vive ahora en su propia pantalla, junto con las
          demas campañas y con el resultado del ultimo envio. Aqui solo el
          camino hacia alla. */}
      <Box sx={{ mt: 1.5 }}>
        <Button
          component={RouterLink} to="/avisos"
          fullWidth size="small" variant="outlined" color="inherit"
          startIcon={<CampaignRoundedIcon />}
        >
          Avisarles por WhatsApp
        </Button>
      </Box>

      <Stack spacing={.5} sx={{ mt: 2, flex: 1 }}>
        {porRenovar.map((cliente, i) => {
          const color = TONO[cliente.plan] || 'primary';
          return (
            <Aparece key={cliente.userId} i={i + 2} sx={{ height: 'auto' }}>
              <Stack
                direction="row"
                spacing={1.5}
                alignItems="center"
                sx={{
                  px: 1, py: .9, borderRadius: 2.5,
                  transition: `background-color .25s ${SUAVE}`,
                  '&:hover': { bgcolor: 'grey.100' },
                }}
              >
                <Avatar
                  sx={{
                    width: 38, height: 38, flexShrink: 0, fontSize: 13.5, fontWeight: 700,
                    bgcolor: `${color}.lighter`, color: `${color}.darker`,
                  }}
                >
                  {iniciales(cliente.nombre)}
                </Avatar>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 600 }} noWrap>
                    {cliente.nombre}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }} noWrap>
                    {cliente.plan} · {cuandoVence(cliente.vence, hoy)}
                  </Typography>
                </Box>

                <Typography sx={{ fontSize: 13, fontWeight: 700, flexShrink: 0, color: 'text.secondary' }}>
                  {soles(cliente.monto)}
                </Typography>

                {/* Abre el chat con el cliente. No manda nada: el mensaje lo
                    escribe quien llama. */}
                {cliente.telefono &&
                  <Tooltip title={`Escribir a ${cliente.nombre}`} arrow>
                    <IconButton
                      component="a"
                      href={`https://wa.me/${String(cliente.telefono).replace(/\D/g, '')}`}
                      target="_blank"
                      rel="noreferrer"
                      size="small"
                      sx={{ flexShrink: 0, color: 'primary.main' }}
                    >
                      <ChatRoundedIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                }
              </Stack>
            </Aparece>
          );
        })}
      </Stack>
    </Card>
  );
}
